module.exports = __webpack_public_path__ + "img/Icon_Contact.3b2a23b4.svg";